import createWidgetFactory from 'components-framework/widget/create_widget_factory';
import View from './view';
import Model from './model';

export default createWidgetFactory({
    name: 'resident_discount',
    modelClass: Model,
    viewClass: View,
    methods: {
        initialize() {
            this.model.getResidentZones();
        },
    },
});
